const englishTranslations = {
  intellect: 'intellect',
  letsSignIn: 'Let’s sign you in',
  welcomeBack: ' Welcome back, we’ve missed you!',
  emailAddress: 'Email Address',
  password: 'Password',
  signIn: 'Sign In',

  ENABLE_TWO_FACTOR: 'Enable two-factor authentication',
  ENABLE_TWO_FACTOR_SUBTITLE:
    'Add an extra layer of security to \nsafeguard your data',
  SET_UP_2FA: 'Set up 2FA',
  SETUP_2FA_HEADER: 'Set up two-factor authentication',
  SETUP_2FA_SUBHEADER: 'Download any authenticator app and scan the QR code',
  SETUP_COPY_CODE:
    'If you are unable to scan the QR code, copy and \npaste this code into the app',
  SETUP_CODE_INPUT_HEADER: 'Enter your code',
  SETUP_CODE_INPUT_SUBHEADER: 'Check your 2FA application for the code',
  AUTHENTICATE: 'Authenticate',
  MFA_INVALID_CODE: 'Invalid code. Please try again!',
  MFA_INVALID_TOKEN:
    'For security reasons, this page will refresh in 3 seconds due to inactivity',
  MFA_ENABLED: 'Two-factor authentication enabled',
  MFA_ENABLED_SUBHEADER:
    "We'll ask for the 6-digit code generated by your authenticator app on your next login",
  GOT_IT_CTA: 'Got it',
  MFA_INPUT_CODE_HEADER: 'Two-factor authentication',
  MFA_INPUT_CODE_SUBHEADER:
    'Launch your authenticator app to receive a 6-digit code \nto access your account.',
  ENTER_YOUR_CODE: 'Enter your code',
  MFA_USER_INFO: 'Why am I seeing this?',
  MFA_NEED_HELP: 'Need help?',
  CONTACT_SUPPORT: 'Contact support',
  CONTACT_SUPPORT_TOAST: "We've received your request to reset your 2FA!",
  MFA_USER_INFO_TOAST:
    'Two-step verification has been enabled for your account.',

  HRDB_BIOMETRIC_VERIFY_HEADER: 'Verify with the Intellect app',
  HRDB_BIOMETRIC_VERIFY_SUBHEADER:
    'Use biometric authentication on the Intellect app to access the HR dashboard',
  NOTIFICATION_HEADER: 'Are you trying to log in?',
  NOTIFICATION_SUBHEADER:
    "Verify that it's you logging into the Intellect dashboard",
  VERIFY_STEP1: 'Tap the notification to open the Intellect app',
  VERIFY_STEP2: 'Click "Yes, it\'s me" and verify your identity',
  NO_NOTIFICATION: "Didn't receive a notification?",
  CLICK_HERE: 'Click here',
  RESEND_NOTIFICATION: 'Resend notification',
  SECONDS_COUNTDOWN: 'sec',
  INSTRUCTIONS_HEADER: 'Need a little help?',
  INSTRUCTIONS_SUBHEADER:
    'Click "resend notification" on the previous page after checking that you\'ve done the following:',
  INSTRUCTIONS_STEP1_HEADER: 'Install the latest version of the Intellect app',
  INSTRUCTIONS_STEP1_SUBHEADER:
    'Download the latest version of the Intellect app',
  INSTRUCTIONS_STEP2_HEADER: 'Keep yourself logged into the Intellect app',
  INSTRUCTIONS_STEP2_SUBHEADER:
    "Check that you're currently logged into the most updated version of the Intellect app",
  INSTRUCTIONS_STEP3_HEADER: 'Intellect app notifications are turned on',
  INSTRUCTIONS_STEP3_SUBHEADER:
    'Go to Settings on your device and allow the Intellect app to send you notifications',
  MANY_RETRY: 'Too many retries! Please try again after sometime. ',
  NOTIFICATION_PREVIEW: 'notificationScreenEn',
  NOTIFICATION_PREVIEW_PROD: 'notificationScreenEn-jbFu8GQK',
  SESSION_EXPIRED_2FA: 'Session expired. Please scan or copy the code again!',
  RESET_2FA_HEADER: 'Reset 2FA?',
  RESET_2FA_CTA: 'Reset 2FA',
  RESET_2FA_SUBHEADER: 'You will be able to set up 2FA again in a few hours',
  REQUEST_RECEIVED_BIOMETRIC:
    "We've received your request. Hold tight, we'll reach out via email soon!",
  TRY_AGAIN_LATER: 'Try again later in few min',
  whoWeAre:
    'Intellect is a modern-day mental health tech company with a \nmission to make mental healthcare & wellbeing support \naccessible for workforces and employees',
  filterYears: '{{- yearValue}} years',

  dashboardViewingUser:
    'You are viewing this dashboard as Relationship manager',
  wellbeingAnalytics: 'Wellbeing Analytics Overview',
  adoptionAnalytics: 'Adoption Analytics',
  appEngagement: 'App Engagement',
  teleHealthUtilization: 'Coaching Utilisation',
  adoptionByDept: 'Adoption by Department ',
  adoptionRateOverview: 'Adoption Data',
  totalSignUps:
    'Number of sign-ups to date including the breakdown by department.',
  filterBy: 'Filter by :',
  overallAdoption: 'Overall Adoption',
  noOfSignUpsInclBreakdown:
    'Number of sign-ups to date including the breakdown by\ncountry or department.',
  breakdownOfSignUpsByCountryOrDept:
    'Breakdown of sign-ups by country or department',
  appEngagementDesc:
    "Employees' engagement with the Intellect self-care app, excluding coaching. ",
  topSessionsToolTipDesc:
    'Across Learning Paths, Rescue Sessions, Guided Journals',
  minutesSpent: '{{ minutes }} minutes',
  frequentEmotionsResponses: '{{ count }} responses',
  noOfResponses: 'Number of responses',
  wellbeingAnalyticsOverview: 'Wellbeing Analytics Overview',
  wellbeingAnalyticsDesc: 'Insights on employees’ wellbeing and stress levels ',
  insufficientData: 'Insufficient Data',
  noData: 'No Data',
  noDataRemoveFilters:
    'Sorry, we don’t have data to display. Please remove filters to see data in this widget',
  date: 'Date',
  learningPath: 'Learning Path',
  rescue: 'Rescue Session',
  journal: 'Journal',
  checkIn: 'Check-in',
  completedUsersCount: '{{ count }} users',
  signUpCount: 'Signup Count',
  appRetention: 'App Retention',
  newUsers: 'New users',
  repeatUsers: 'Repeat users',
  activeUsers: 'Active users',
  overallInsights: 'Overall Insights',
  otherInsights: 'Other Insights',
  breakdownByDept: 'Breakdown of sign-ups by department',
  sideBarMainAction: 'MAIN ACTION',
  sideBarWellBeing: 'Wellbeing Analytics',
  sideBarAdoptionData: 'Adoption Data',
  sideBarAppEngagement: 'App Engagement',
  sideBarCoachingUtilisation: 'Coaching Utilisation',
  wellBeingTabTitle: 'Wellbeing Analytics Overview',
  wellBeingTabDescription: "Insights on employees' wellbeing and stress levels",
  dateFilterMonthCurrent: 'Current Month',
  dateFilterMonthItem_one: 'Last {{ count }} Month',
  dateFilterMonthItem_other: 'Last {{ count }} Months',
  chartDisplayTitle: 'Chart Display',
  chartDisplayAbsoluteNos: 'Absolute Numbers',
  chartDisplayPercentage: 'Percentage',
  chartDisplayGrouped: 'Grouped',
  filterTitle: 'Filters',
  filterRegionTitle: 'Region',
  filterDepartmentTitle: 'Department',
  filterGenderTitle: 'Gender',
  filterAgeGroupTitle: 'Age Group',
  filterApply: 'Apply Filter',
  filterCancel: 'Cancel',
  filterReset: 'Reset',
  filterResetAll: 'Reset All',
  filterSelectAll: 'Select All',
  filterSearch: 'Search',
  filterGenderMale: 'Male',
  filterGenderFemale: 'Female',
  filterGenderNonBinary: 'Non-binary',
  filterGenderUnknown: 'Unknown',
  NOT_DISCLOSED: 'Not disclosed',
  filterAgeValue: '{{- yearValue}} years',
  YEARS: 'years',
  filterNoOptionsFound: 'No results found.',
  adoptionTabDescription:
    'Total signs-ups to date (current and former employees) including the breakdown by department',
  appEngagementTabDescription:
    "Employees' engagement with the Intellect self-care app, excluding coaching.",
  appEngagementLearningPath: 'Learning Path',
  appEngagementRescue: 'Rescue Session',
  appEngagementJournal: 'Journal',
  appEngagementCheckIn: 'Check-in',
  genericTextUsers: '{{ count }} users',
  genericTextResponses: '{{ count }} responses',
  providerOverallInsights: 'Insights: Coaching, Clinical and other sessions',
  providerOtherInsights: 'Other Insights',
  clinicalUtilisation: 'Clinical Utilisation',
  coachingUtilisation: 'Coaching Utilisation',
  logout: 'Logout',
  loginIntellect: 'intellect',
  loginLetsSignIn: 'Let’s sign you in',
  loginWelcomeBack: ' Welcome back, we’ve missed you!',
  loginEmailAddress: 'Email Address',
  loginPassword: 'Password',
  loginSignIn: 'Sign In',
  loginWhoWeAre:
    'Intellect is a modern-day mental health tech company with a \nmission to make mental healthcare & wellbeing support \naccessible for workforces and employees',
  ssoButtonText: 'Login with SSO',
  passwordLoginButtonText: 'Login with password',
  orgNotActivatedSSO: 'This domain is not yet SSO-enabled.',
  ssoForEmailIsActive:
    'This email is associated with SSO. Please login with SSO.',
  ssoTokenVerifying: 'Authenticating...in progress.',
  ssoTokenVerifyFailedHeading: 'Authentication failed. Please try again.',
  ssoTokenVerifyFailedText:
    'Please close this tab if it does not do so automatically.',
  intellectDimensions: 'Organisational Dimensions',
  learnMore: 'Learn More',
  yourScore: 'Your Score',
  benchmark: 'Benchmark',
  intellectBenchmark: 'Intellect Benchmark',
  healthyAverageScore: 'Healthy Average Score',
  lastUpdatedOn: 'Last updated on ',
  employeeCount: '{{ count }} employees',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  score: 'Score',
  scoreMeaning: 'What does this score mean?',
  notEnoughInfo: 'Not enough information',
  noDataDesc:
    'Aggregate data can only be shown when there are more than 10 employees taking the test',
  insightsAboveAvg:
    'You are <span class="text-[#00AA5B] font-bold">{{diff}} points above</span> the healthy average<br/> compared to the Intellect benchmark.',
  insightsBelowAvg:
    'You are <span class="text-[#E8324A] font-bold">{{diff}} points below</span> the healthy average compared to the Intellect benchmark.',
  insightsAtAvg:
    'You are <span class="text-[#00AA5B] font-bold">at the average</span> score compared to the Intellect benchmark.',
  generatedReportsNote: 'Generated reports will be displayed here.',

  REPORTS: 'Reports',
  REPORT_TYPE: 'Select report type',
  INSIGHTS_REPORT: 'Intellect Insights',
  TIMEFRAME: 'Timeframe',
  EXPORT_TO: 'Export to',
  GENERATE_REPORT: 'Generate report',
  PAST_REPORTS: 'Past reports',
  PAST_REPORTS_SUBHEADER: 'Download records from the last 6 months shown here',
  GENERATED_ON: 'Generated on',
  REPORT_FOR: 'Report for',
  INTERNET_LOST: 'Internet connection lost',
  MONTH: 'Month',
  MONTHS: 'Months',
  OR: 'or',
  DATE: 'Date',
  FAILED_TO_GENERATE: 'Failed to generate',
  DISPLAY_GENERATE_REPORTS: 'Generated reports will be displayed here.',
  TOAST_REPORT_GENERATED: 'Report is being generated',
  TOAST_CONTACT_CS:
    'The report generation has failed, Please contact your CS manager.',
  TOAST_DOWNLOADED: 'Download successful',
  TOAST_DOWNLOAD_READY: 'Report ready for download',
  LAST: 'Last',
  FILTERS_SAMPLE_DATA_NOTE:
    'Note that after applying filters, the sample data remains unchanged.',
  organisation: 'organisation',

  DOWNLOAD_REPORTS: 'Download reports',
  DOWNLOAD_REPORTS_SUBHEADING:
    'Simply choose a time period and download a comprehensive report covering all sections of the dashboard',
  // DOWNLOAD_REPORT	Download report
  SELECT: 'Select',
  SEARCH: 'Search',
  SELECT_ALL_MATCHING: 'Select all matching',
  APPLY: 'Apply',
  ALL_TIME: 'All time',
  CUSTOM_DATE: 'Custom date',
  SELECT_DATES: 'Select date',
  FROM: 'From',
  To: 'to',
  TO: 'To',
  PAGE: 'Page',
  ALL_PAGES: 'All pages',
  DOWNLOAD_AS: 'Download as',
  DOWNLOAD: 'Download',
  REPORT_SUCCESS_HEADING: 'Your report is generated',
  REPORT_SUCCESS_SUBHEADING:
    'Your report has been generated successfully. Download will start soon',
  REPORT_SUCCESS_TOAST_HEADING: 'Your report is downloaded!',
  REPORT_SUCCESS_TOAST_SUBHEADING:
    'Your report has been generated successfully downloaded',
  REPORT_FAIL_HEADING: 'Report generation failed!',
  REPORT_FAIL_SUBHEADING:
    'Something went wrong with your report generation, please try again later!',
  PAST_REPORTS_SUBHEADING:
    'Here’s a log of the reports you have downloaded in the past',
  OKAY: 'Okay',
  NO_REPORTS: 'No reports',
  NO_REPORTS_SUBHEADING: 'Generated reports will be displayed here',

  SUBMIT_FEEDBACK_SUBHEADING:
    'Please share your experience with this new version so we can make it more useful for you.',
  SUBMIT_FEEDBACK_QUESTION1: 'How helpful is the dashboard for you?',
  BAD: 'Not helpful',
  OK: 'Somewhat helpful',
  GOOD: 'Very helpful',
  SUBMIT_FEEDBACK_QUESTION2: "Let us know what didn't work for you.",
  SELECT_MORE: 'You may choose more than one option',
  UNCLEAR_DESCRIPTIONS: 'Unclear descriptions',
  UNHELPFULE_DATA: 'Unhelpful data',
  MMISSING_KEY_DATA: 'Missing/irrelevant data',
  NOT_EASY_TO_USE: 'Not easy to use',
  LOADING_SPEED: 'Loading speed',
  POOR_DATA_VISUALISATION: 'Poor data visualisation',
  TOO_MUCH_INFO: 'Too much info',
  SUBMIT_FEEDBACK_QUESTION3:
    'We’re so glad you liked the new version. Please select the aspects you found most useful.',
  CLEAR_DESCRIPTIONS: 'Clear descriptions',
  SUFFICIENT_DATA: 'Sufficient data',
  HELPFUL_DATA: 'Relevant/ Helpful data',
  GOOD_DATA_VISUALISATION: 'Good data visualisation',
  RELEVANT_INFO: 'Comprehensive info',
  EASY_TO_USE: 'Easy to use',
  ADDITIONAL_COMMENTS: 'How can we make this dashboard more helpful for you?',
  WRITE_ADDITIONAL_INFO: 'It would be helpful if...',
  CHARACTERS: 'characters',
  SUBMIT_FEEDBACK: 'Share feedback',
  FEEDBACK_SUCCESS_HEADING: 'Thanks for your feedback!',
  FEEDBACK_SUCCESS_SUBHEADING:
    'Your views and thoughts are important to us as we are constantly improving our experience',
  FEEDBACK_SUCCESS_BUTTON: 'Ok, great',
  FEEDBACK_BANNER_HEADING: 'What do you think of the new dashboard?',
  FEEDBACK_BANNER_SUBHEADING:
    'We\'d love your thoughts on the new version! Share your feedback now. If you\'d prefer to do it later, you can do so by clicking the menu in the top right and selecting "Share feedback"',
  MANDATORY_FIELDS: 'Mandatory fields',
  LAST_UPDATED_AT: 'Last updated at',
  AT: 'at',
  YOU_ARE_VIEWING_DATA_FROM: 'You are viewing data from',
  ORG_DIMS_DATE_RANGE_NOTICE:
    'We are showing data from {{ fromDate }} to {{ toDate }} with a sample size of {{ userCount }}. Data on this page is calculated every 14 days after looking at responses in a rolling 6 month time window. Next update on {{ nextUpdateDate }}',
  ORG_DIMS_NO_DATA_NOTICE:
    'No data to show for the selected filters. Please change these filters to view data on this page',
  LATEST_6_MONTH_DATA: 'Latest 6 month data',
  HOW_ORG_DIMS_WORK: 'Download 2024 white paper',
  HOW_ORG_DIMS_WORK_DESC:
    'Download our 2024 dimensions benchmarking report for 10 APAC industries',
  QUICK_GUIDE_DEFINITIONS: 'Quick guide: definitions',
  QUICK_GUIDE_DEFINITIONS_DESC:
    'Quick guide: definitions of organisational dimensions',
  HOW_EMP_TAKE_PI_QUIZ: 'Personal insights quiz',
  HOW_EMP_TAKE_PI_QUIZ_DESC:
    'Responses to the personal insights quiz give us dimension scores for your org.',
  VS_LAST_PERIOD: 'vs last period',
  NO_CHANGE_SINCE_LAST_PERIOD: 'No change since last period',
  MORE_FILTER: 'More filters',
  FILTERS_ARE_SHOWN_HERE: 'Filters are shown here',
  FILTERS: 'filters',
  FILTER: 'filter',
  SELECTED: 'selected',
  SELECT_TIME: 'Select time',
  CARE_UTILISATION: 'Care utilisation',
  COACHING: 'Coaching',
  CLINICAL: 'Clinical',
  EAP: 'EAP',
  HOLISTIC: 'Holistic',
  ADOPTION: 'Adoption',
  MOOD_CHECK_IN: 'Mood Check-in',

  SAY_HELLO: 'Upgrade to the new dashboard',
  SAY_HELLO_PARAGRAPH:
    'Check out our new dashboard with more data, clearer definitions, and a cleaner look.',
  SWITCH_TO_NEW: 'Take me to the new dashboard →',
  SWITCH_TO_OLD: 'Switch to old dashboard',
  SUNSET_POPUP_HEADING: 'Helpful Info',
  SUNSET_POPUP_SUBHEADING:
    'We are excited for you to upgrade to the new dashboard! The previous version will remain available for the next few weeks. During this period, you can switch back by clicking the profile icon on the top right of the new dashboard.',
  CONTINUE: 'Continue',
  USE_SSO_INSTEAD: 'Use SSO instead',
  NO_DATA: 'No data to show for fewer than 5 active users',
  LOGIN_HEADLINE:
    'We Help 3.5 Million Members Worldwide Raise the Bar for Mental Health Access and Quality',
  SIGN_OUT: 'Sign out',
  GET_STARTED: 'Get started',
  ARE_YOU_SURE: 'Are you sure?',
  LOGOUT_ALERT_MESSAGE:
    'Are you sure you don’t want to proceed, you will be logged out. You can try log back in with same or different account',

  OOPS: 'Oops',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  REFRESH_PAGE: 'Please refresh the page',
  RELOAD: 'Reload',

  NPS_HEADING: 'Please rate the quality of insights on this dashboard',
  NPS_RATING_ZERO: 'Not useful at all',
  NPS_RATING_TEN: 'Excellent',
  NPS_THANK_YOU: 'Thank you for your feedback.',
  BREAKDOWN: 'Breakdown',
  RESET_SELECTION: 'Reset Selection',
  AUTH_TOO_MANY_RETRY:
    "Oops! You've tried logging in too many times. Please wait a few minutes and try again.",

  BENCHMARK_AGAINST: 'Benchmark against',
  GLOBAL: 'Global',
  INDUSTRY: 'Industry',
  AVERAGE: 'average',
  AVG: 'Avg',
  INFO: 'Info',
  RESOURCES_LEARN_MORE_HEADING: 'FAQ documents & personal insights quiz',
  LEARN_MORE: 'Learn more',
  HIDE: 'Hide',
  RESOURCES_LEARN_MORE_TITLE: 'Download Files to learn more',
  FILE: 'File',
  OVERVIEW: 'Overview',
  SCORE: 'Score',
  YOUR_SCORE: 'Your Score',
  RECOMMENDATIONS: 'Recommendations',
  RECOMMENDATIONS_FILE_DESCRIPTION:
    'Download a one-page summary of our recommendations to help you improve your score',
  BENCHMARKS: 'Benchmarks',
  UNIQUE_RESPONDENTS: 'Unique respondents',
  TWO_Y_AXIS: '2Y axis',
  VERTICAL_CHART_DATA_ALERT_TITLE:
    'Quarters shown with lighter bars haven’t reached the minimum response threshold yet.',
  VERTICAL_CHART_DATA_ALERT_DESCRIPTION:
    'We need at least 20 respondents for small (<100), 40 for medium (100–999), and 80 for large (≥1000) organisations to ensure statistical validity',
  HORIZONTAL_CHART_DATA_ALERT_TITLE:
    'Some groups haven’t reached the minimum response threshold and are hidden from this view',
  HORIZONTAL_CHART_DATA_ALERT_DESCRIPTION:
    'We need a minimum of 5 unique respondents per group in the selected time period to ensure confidentiality',
  THRIVING_CUTOFF: 'Thriving cutoff',
  NEEDS_ATTENTION_CUTOFF: 'Needs attention cutoff',
  QUARTER: 'Quarter',
  QUARTERS: 'Quarters',
  DIMENSION_SCORE_EMPTY_STATE_HEADING:
    "The quarters selected haven't reached the minimum response threshold yet",
  DIMENSION_SCORE_EMPTY_STATE_SUB_HEADING:
    'We need a minimum of 5 respondents to maintain statistical validity.',

  BENCHMARK_SCORE_EMPTY_STATE_HEADING: 'No insights available',
  BENCHMARK_SCORE_EMPTY_STATE_SUB_HEADING: `The chosen filters or date range don't contain any data. Try changing the filters or date range to see results. `,

  FAQ_FILE_DIMENSIONS: 'FAQ: Dimensions',
  FAQ_FILE_DIMENSIONS_DESC:
    'All frequently asked questions answered in one single file',

  RECOMMENDATIONS_EMPTY:
    'Sorry, no recommendations to show here. Please refresh or change filters',

  NO_INSIGHTS_AVAILABLE: 'No insights available',
  NO_INSIGHTS_AVAILABLE_DESCRIPTION:
    "The chosen filters or date range don't contain any data. Try changing the filters or date range to see results. ",
};

export default englishTranslations;
